package com.castly.admin.ui

import com.castly.admin.ui.theme.AppColors
import com.castly.admin.ui.theme.BorderRadius
import com.castly.admin.ui.theme.LightColors
import com.castly.admin.ui.theme.Shadow
import com.castly.admin.ui.theme.Spacing
import com.castly.admin.ui.theme.Typography
import com.castly.admin.ui.theme.themeTransition
import org.jetbrains.compose.web.css.*

fun StyleScope.tableHeaderStyle(colors: AppColors = LightColors) {
    padding(Spacing.md)
    textAlign("left")
    fontSize(Typography.sm)
    fontWeight("600")
    color(Color(colors.textMuted))
    property("text-transform", "uppercase")
    backgroundColor(Color(colors.surfaceHover))
    property("border-bottom", "1px solid ${colors.border}")
    themeTransition()
}

fun StyleScope.paginationButtonStyle(disabled: Boolean, colors: AppColors = LightColors) {
    padding(Spacing.sm, Spacing.lg)
    backgroundColor(Color(if (disabled) colors.surfaceHover else colors.surface))
    color(Color(if (disabled) colors.textMuted else colors.text))
    border(1.px, LineStyle.Solid, Color(colors.border))
    borderRadius(BorderRadius.md)
    cursor(if (disabled) "not-allowed" else "pointer")
    fontSize(Typography.base)
    themeTransition()
}

fun StyleScope.formInputStyle(colors: AppColors = LightColors) {
    width(100.percent)
    padding(Spacing.md, Typography.base)
    fontSize(Typography.base)
    color(Color(colors.text))
    backgroundColor(Color(colors.surface))
    border(1.px, LineStyle.Solid, Color(colors.border))
    borderRadius(BorderRadius.md)
    property("outline", "none")
    themeTransition()
}

fun StyleScope.modalOverlayStyle(colors: AppColors = LightColors) {
    position(Position.Fixed)
    top(0.px)
    left(0.px)
    right(0.px)
    bottom(0.px)
    backgroundColor(Color("rgba(0, 0, 0, 0.5)"))
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(AlignItems.Center)
    property("z-index", "1000")
}

fun StyleScope.modalContentStyle(colors: AppColors = LightColors) {
    backgroundColor(Color(colors.surface))
    borderRadius(BorderRadius.lg)
    padding(Spacing.xxl)
    maxWidth(600.px)
    maxHeight(90.vh)
    property("overflow-y", "auto")
    width(90.vw)
    border(1.px, LineStyle.Solid, Color(colors.border))
    color(Color(colors.text))
    themeTransition()
}

fun StyleScope.confirmationOverlayStyle(colors: AppColors = LightColors) {
    position(Position.Fixed)
    top(0.px)
    left(0.px)
    right(0.px)
    bottom(0.px)
    backgroundColor(Color("rgba(0, 0, 0, 0.7)"))
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(AlignItems.Center)
    property("z-index", "1001")
}

fun StyleScope.confirmationContentStyle(colors: AppColors = LightColors) {
    backgroundColor(Color(colors.surface))
    borderRadius(BorderRadius.lg)
    padding(Spacing.xxl)
    maxWidth(400.px)
    border(1.px, LineStyle.Solid, Color(colors.border))
    color(Color(colors.text))
    themeTransition()
}

fun StyleScope.primaryButtonStyle(disabled: Boolean = false, colors: AppColors = LightColors) {
    padding(Spacing.md, Spacing.xl)
    backgroundColor(Color(if (disabled) colors.textMuted else colors.primary))
    color(Color("#ffffff"))
    border(0.px)
    borderRadius(BorderRadius.md)
    cursor(if (disabled) "not-allowed" else "pointer")
    fontSize(Typography.base)
    fontWeight("600")
    property("transition", "background-color 0.2s ease")
}

fun StyleScope.secondaryButtonStyle(colors: AppColors = LightColors) {
    padding(Spacing.md, Spacing.xl)
    backgroundColor(Color(colors.surface))
    color(Color(colors.text))
    border(1.px, LineStyle.Solid, Color(colors.border))
    borderRadius(BorderRadius.md)
    cursor("pointer")
    fontSize(Typography.base)
    fontWeight("600")
    property("transition", "background-color 0.2s ease, border-color 0.2s ease")
}

fun StyleScope.successButtonStyle(colors: AppColors = LightColors) {
    padding(Spacing.md, Spacing.xl)
    backgroundColor(Color(colors.success))
    color(Color("#ffffff"))
    border(0.px)
    borderRadius(BorderRadius.md)
    cursor("pointer")
    fontSize(Typography.base)
    fontWeight("600")
    property("transition", "background-color 0.2s ease")
}

fun StyleScope.errorMessageStyle(colors: AppColors = LightColors) {
    padding(Spacing.md)
    backgroundColor(Color(if (colors == LightColors) "#fee2e2" else "#450a0a"))
    color(Color(if (colors == LightColors) "#b91c1c" else "#fca5a5"))
    borderRadius(BorderRadius.md)
    marginBottom(Spacing.md)
    themeTransition()
}

fun StyleScope.successMessageStyle(colors: AppColors = LightColors) {
    padding(Spacing.sm)
    backgroundColor(Color(if (colors == LightColors) "#d1fae5" else "#052e16"))
    color(Color(if (colors == LightColors) "#065f46" else "#86efac"))
    borderRadius(BorderRadius.sm)
    marginBottom(Spacing.sm)
    fontSize(Typography.sm)
    themeTransition()
}

fun StyleScope.infoBoxStyle(colors: AppColors = LightColors) {
    padding(Spacing.sm)
    backgroundColor(Color(if (colors == LightColors) "#f0f9ff" else "#0c1929"))
    color(Color(if (colors == LightColors) "#1e40af" else "#93c5fd"))
    borderRadius(BorderRadius.sm)
    marginBottom(Spacing.sm)
    fontSize(Typography.sm)
    property("word-break", "break-all")
    themeTransition()
}
